module.exports = __webpack_public_path__ + "media/images/pop-logo-6c0f45e4.svg";